var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import { flowsApi } from 'apis/flows';
import { usePaginatedEndpoint } from 'utils/apis/pagination/usePaginatedEndpoint';
/**
 * A hook that handles fetching, updating schedules on the business hours
 * overview page.
 */
export function useSchedules() {
    const [currentPageSchedules, setCurrentPageSchedules] = useState([]);
    const { asyncStatus, hasNextPage, hasPreviousPage, items, total: totalNumberOfSchedules = 0, nextPage, previousPage, refetchItems, } = usePaginatedEndpoint({
        endpoint: flowsApi.endpoints.readFlowsSchedules,
        initialArg: {},
        itemsSelector: ({ data: { schedules } }) => schedules,
        totalSelector: ({ data: { total_number_of_schedules } }) => total_number_of_schedules,
    });
    const { schedulesInConflicts, refetch: refetchSchedulesInConflicts } = flowsApi.useReadFlowsSchedulesConflictsQuery(undefined, {
        selectFromResult: (_a) => {
            var _b;
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { schedulesInConflicts: (_b = data === null || data === void 0 ? void 0 : data.data.schedules_in_conflicts) !== null && _b !== void 0 ? _b : [] }));
        },
    });
    // Updates local state of current page schedules that is used for
    // populating the table.
    useEffect(() => {
        setCurrentPageSchedules(items);
    }, [items]);
    return {
        asyncStatus,
        currentPageSchedules,
        hasNextPage,
        hasPreviousPage,
        schedulesInConflicts,
        totalNumberOfSchedules,
        nextPage,
        previousPage,
        refetchItems,
        refetchSchedulesInConflicts,
    };
}
